export default class ProductDetailTabTypeModel {
  TabTypeId: number | null;
  TabKey: string;
  DefaultTitle: string;
  ContentType: string;
  ContentConfig: Record<string, unknown>;
  Placement: string;
  HelpText: string;
  DisplayOrder: number;
  IsActive: boolean;

  constructor() {
    this.TabTypeId = null;
    this.TabKey = '';
    this.DefaultTitle = '';
    this.ContentType = 'html_block';
    this.ContentConfig = {};
    this.Placement = 'tab';
    this.HelpText = '';
    this.DisplayOrder = 0;
    this.IsActive = true;
  }
}
